import React from 'react';
import classnames from 'classnames';
import Spinner from 'react-spinkit';
import Description from './description';
import ProductAddToCart from './addToCart';
import ProductVariants from './variants';
import ProductIngredients from './ingredients';
import StarRating from 'scy/StarRating';
import { textCenter } from 'scy/utils.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

export default function ProductSummary(props) {
  if (props.loading) return <Loading />;

  const product = props.product || {};
  const { title, subtitle, description, description_html } = product;
  const ingredientsWithOptions = (product.ingredients || []).filter(
    ingredient => !!(ingredient.options || []).length
  );

  return (
    <section className={styles.productInfoRightColumn}>
      <h1 className={`${styles.title} ${margin.bottom_xs}`}>
        {title}
        {subtitle && ` – ${subtitle}`}
      </h1>

      <StarRating
        className={margin.bottom_xs}
        ratings={{
          ratingCount: props.ratingCount,
          ratingValue: props.ratingValue
        }}
        loading={props.loadingDetails}
      />

      <div className="row">
        <div className="col-xs-12 col-sm-10 col-md-9">
          <ProductVariants className={margin.bottom_sm} product={product} />

          {!!ingredientsWithOptions.length && (
            <ProductIngredients
              ingredients={ingredientsWithOptions}
              sku={product.sku_id}
            />
          )}

          <ProductAddToCart product={product} />
        </div>
      </div>

      <Description
        description={description}
        description_html={description_html}
      />
    </section>
  );
}

function Loading() {
  return (
    <div
      className={classnames(
        margin.top_xl,
        margin.bottom_xl,
        margin.sides_auto,
        textCenter
      )}
    >
      <Spinner spinnerName="three-bounce" />
    </div>
  );
}
